<template>
  <div class="vue-wrapper">
    <TheLoader :active="loading"/>
    <div v-if="!loading" class="content-container flex-row">
      <div class="sidebar left fixed subnav show-for-large">
        <div class="fixed-container">
          <scrollactive active-class="active" :highlightFirstItem="true" :offset="96" :duration="500" :modifyUrl="false" bezier-easing-value="0.455,0.03,0.515,0.955">
            <ul>
              <li><a href="#bruker-edit-section-0" class="scrollactive-item active" :class="{'error': sectionErrors.hasOwnProperty('bruker-edit-section-0')}">Innstillinger <span class="count" v-if="sectionErrors.hasOwnProperty('bruker-edit-section-0')">{{sectionErrors['bruker-edit-section-0']}}</span></a></li>
              <li><a href="#bruker-edit-section-1" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('bruker-edit-section-1')}">Personalia <span class="count" v-if="sectionErrors.hasOwnProperty('bruker-edit-section-1')">{{sectionErrors['bruker-edit-section-1']}}</span></a></li>
              <li><a href="#bruker-edit-section-2" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('bruker-edit-section-2')}">Passord <span class="count" v-if="sectionErrors.hasOwnProperty('bruker-edit-section-2')">{{sectionErrors['bruker-edit-section-2']}}</span></a></li>
              <li><a href="#bruker-edit-section-3" class="scrollactive-item" :class="{'error': sectionErrors.hasOwnProperty('bruker-edit-section-3')}">Webb Innstillinger <span class="count" v-if="sectionErrors.hasOwnProperty('bruker-edit-section-3')">{{sectionErrors['bruker-edit-section-3']}}</span></a></li>
            </ul>
          </scrollactive>
        </div>
      </div>

      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <div class="scroll-section" id="bruker-edit-section-0">
            <h2>Innstillinger</h2>

            <fieldset>
              <div class="grid-x grid-padding-x">
                <TheSelectInput v-model="form.Rolle" containerClassName="cell large-6" label="Rolle" name="Rolle" required v-validate="'required|integer|min:0'" data-vv-validate-on="input" :items="instillinger.rolle"/>
                <TheSelectInput v-model="form.Avdelingsid" containerClassName="cell large-6" label="Avdeling" name="Avdelingsid" required v-validate="'required|integer|min:0'" data-vv-validate-on="input" :items="instillinger.avdeling"/>
                <TheSelectInput v-model="form.Expertavdelingsid" containerClassName="cell medium-6" label="Ekspertavdeling" name="Expertavdelingsid" data-vv-validate-on="input" :items="instillinger.expertavdeling" :disabled="!hasAvdeling"/>
                <TheSelectInput v-model="form.Mottakerforfirma" containerClassName="cell large-6" label="Mottaker for firma" name="Mottakerforfirma" required v-validate="'required'" data-vv-validate-on="input" :items="instillinger.mottakerforfirma"/>
                <TheIntegerInput v-model="form.twentyfourseven_id_art_trade" containerClassName="cell large-6" label="Employeeid på 247 (kunst)" name="twentyfourseven_id_art_trade" v-validate="'integer'"/>
                <TheIntegerInput v-model="form.twentyfourseven_id_web_auction" containerClassName="cell large-6" label="Employeeid på 247 (nett)" name="twentyfourseven_id_web_auction" v-validate="'integer'"/>
              </div>
            </fieldset>

            <fieldset>
              <div class="grid-x grid-padding-x">
                <div class="cell">
                  <ul class="switch-list">
                    <TheSwitchListSwitchInput v-model="form.Inaktiv" labelTrue="Aktiv" labelFalse="Aktiv" trueValue="F" falseValue="T"/>
                    <TheSwitchListSwitchInput v-model="form.Ekspert" labelTrue="Ekspert" labelFalse="Ekspert" />
                    <TheSwitchListSwitchInput v-model="form.vin" labelTrue="vin" labelFalse="vin" :trueValue="1" :falseValue="0"/>
                    <TheSwitchListSwitchInput v-model="form.Minekunder" labelTrue="Mine kunder" labelFalse="Mine kunder"/>
                  </ul>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="bruker-edit-section-1">
            <h2>Personalia</h2>
            <fieldset>
              <div class="grid-x grid-padding-x">
                <div class="cell large-6">
                  <label for="Brukernavn">Brukernavn * <span v-show="burkernavnCheck">søker...</span></label>
                  <div class="input-container text" :class="[errors.has('Brukernavn') ? 'form-error' : '', !!edit ? 'disabled': '']">
                    <input
                      id="Brukernavn"
                      name="Brukernavn"
                      type="text"
                      class="uppercase"
                      maxlength="10"
                      v-model.trim="form.Brukernavn"
                      v-validate="'required|min:2|max:10|unique-brukernavn'"
                      :class="{'error': errors.has('Brukernavn')}"
                      :disabled="edit"
                    >
                    <span class="glyph" v-show="!!edit">
                      <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-disabled"></use></svg>
                    </span>
                    <span class="form-error-label" v-if="errors.has('Brukernavn')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Brukernavn')}}
                    </span>
                  </div>
                </div>

                <div class="cell large-6">
                  <label for="Email">Email * <span v-show="emailCheck">Checking...</span></label>
                  <div class="input-container text" :class="{'form-error': errors.has('Email')}">
                    <input
                      id="Email"
                      name="Email"
                      type="text"
                      class="lowercase"
                      v-model.trim="form.Email"
                      v-validate="'required|email|unique-email'"
                      :class="{'error': errors.has('Email')}"
                    >
                    <span class="form-error-label" v-if="errors.has('Email')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Email')}}
                    </span>
                  </div>
                </div>

                <div class="cell large-4">
                  <label for="Fornavn">Fornavn</label>
                  <div class="input-container text" :class="{'form-error': errors.has('Fornavn')}">
                    <input id="Fornavn" name="Fornavn" type="text" v-model.trim="form.Fornavn" v-validate="'max:50'" :class="{'error': errors.has('Fornavn')}">
                    <span class="form-error-label" v-if="errors.has('Fornavn')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Fornavn')}}
                    </span>
                  </div>
                </div>

                <div class="cell large-4">
                  <label for="Mellomnavn">Mellomnavn</label>
                  <div class="input-container text" :class="{'form-error': errors.has('Mellomnavn')}">
                    <input id="Mellomnavn" name="Mellomnavn" type="text" v-model.trim="form.Mellomnavn" v-validate="'max:25'" :class="{'error': errors.has('Mellomnavn')}">
                    <span class="form-error-label" v-if="errors.has('Mellomnavn')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Mellomnavn')}}
                    </span>
                  </div>
                </div>

                <div class="cell large-4">
                  <label for="Etternavn">Etternavn</label>
                  <div class="input-container text" :class="{'form-error': errors.has('Etternavn')}">
                    <input id="Etternavn" name="Etternavn" type="text" v-model.trim="form.Etternavn" v-validate="'max:50'" :class="{'error': errors.has('Etternavn')}">
                    <span class="form-error-label" v-if="errors.has('Etternavn')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Etternavn')}}
                    </span>
                  </div>
                </div>

                <ThePhoneInput containerClassName="cell large-4" label="Mobil" id="mobile_phone" name="Mobil" :required="form.mobile_phone" v-model.trim="form.mobile_phone" maxlength="20" v-validate="'required|max:20'"/>

              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="bruker-edit-section-2">
            <h2>Passord</h2>
            <fieldset>
              <div class="grid-x grid-padding-x">
                <div class="cell large-6">
                  <label for="Passord">Passord<span v-if="!edit"> *</span></label>
                  <div class="input-container text" :class="{'form-error': errors.has('Passord')}">
                    <input id="Passord" name="Passord" type="text" ref="Passord" v-model.trim="form.Passord" v-validate="rules.Passord" :class="{'error': errors.has('Passord')}">
                    <span class="form-error-label" v-if="errors.has('Passord')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('Passord')}}
                    </span>
                  </div>
                </div>

                <div class="cell large-6">
                  <label for="PassordRepeat">Passord igjen <span v-if="!edit"> *</span></label>
                  <div class="input-container text" :class="{'form-error': errors.has('PassordRepeat')}">
                    <input id="PassordRepeat" name="PassordRepeat" type="text" v-model.trim="form.PassordRepeat" v-validate="rules.PassordRepeat" :class="{'error': errors.has('PassordRepeat')}">
                    <span class="form-error-label" v-if="errors.has('PassordRepeat')">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                      {{errors.first('PassordRepeat')}}
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="scroll-section" id="bruker-edit-section-3">
              <h2>Webb Innstillinger</h2>
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <div class="cell">
                    <ul class="checkbox-list">
                      <li v-for="item in w_items" v-bind:key="item.key">
                        <div class="input-container checkbox">
                          <input type="checkbox" :id="item.key" :key="item.key" :value="item.key" v-model="w_items_checked">
                          <label :for="item.key">{{item.name}}</label>
                          <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </fieldset>
            </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import BrukerService from '@/services/BrukerService'
import MiscService from '@/services/MiscService'
import DummyCache from '@/plugins/dummy-cache.js'
import bus from '@/plugins/event-bus'

export default {
  name: 'BrukerCardForm',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    bruker: {
      type: Object,
      required: false,
      default: () => {
        return {
          Passord: null,
          PassordRepeat: null
        }
      }
    }
  },
  data () {
    return {
      edit: false,
      form: {},
      sectionErrors: {},
      rules: {
        Passord: 'min:6|password-secure',
        PassordRepeat: 'confirmed:Passord'
      },
      w_items: [
        {key: 'W_abonnent', name: 'Abbonent'},
        {key: 'W_auksjon', name: 'Auksjon'},
        {key: 'W_forhbud', name: 'Forhbud'},
        {key: 'W_kategori', name: 'Kategori'},
        {key: 'W_kontrakt', name: 'Kontrakt'},
        {key: 'W_kunde', name: 'Kunde'},
        {key: 'W_kunstner', name: 'Kunstner'},
        {key: 'W_land_post', name: 'Land post'},
        {key: 'W_objekt', name: 'Objekt'},
        {key: 'W_regnskap', name: 'Regnskap'},
        {key: 'W_reskontro', name: 'Reskontro'},
        {key: 'W_spader', name: 'Spader'}
      ],
      w_items_checked: [],
      instillinger: {
        rolle: [],
        avdeling: [],
        expertavdeling: [],
        mottakerforfirma: [
          {key: 'ALLE', val: 'ALLE'},
          {key: 'BEGGE', val: 'BEGGE'},
          {key: 'INGEN', val: 'INGEN'},
          {key: 'LYSAKER', val: 'LYSAKER'},
          {key: 'SENTRUM', val: 'SENTRUM'},
          {key: 'VIN', val: 'VIN'}
        ]
      },
      firstLoadExpertavdeling: true,
      burkernavnCheck: false,
      emailCheck: false,
      loading: true
    }
  },
  mounted () {
    // Listen to submit form event from parent - cus button is in parent
    bus.$on('bruker-form-submit', () => this.handleSubmit())
  },

  created () {
    // Must turn off the event listener in case it is already there...
    bus.$off('bruker-form-submit')

    // Set form not submittable
    this.setFormLoading(true)

    // Edit or New?
    this.edit = !!this.bruker.Brukerid

    if (!this.edit) {
      this.rules.Passord = 'required|min:6|password-secure'
      this.rules.PassordRepeat = 'required|confirmed:Passord'
    }

    // Create an cache container, so we don't have to do api requests if same email/brukernavn is sent twice...
    this.emailCheckCache = new DummyCache()
    this.brukernavnCheckCache = new DummyCache()

    // Secure password
    this.$validator.extend('password-secure', {
      validate: this.$helpers.passwordStrongnessRule,
      getMessage: (field, params, data) => data ? data.message : 'Passordet er ikke sikkert nok'
    })

    // Unique brukernavn check
    this.$validator.extend('unique-brukernavn', {
      validate: this.uniqueBrukernavnCheck,
      getMessage: (field, params, data) => data ? data.message : 'Brukernavn finnes allerede i database'
    })

    // Unique email check
    this.$validator.extend('unique-email', {
      validate: this.uniqueEmailCheck,
      getMessage: (field, params, data) => data ? data.message : 'Email finnes allerede i database'
    })

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  watch: {
    'form.Avdelingsid': function (val, oldVal) {
      // Reset expertavdelings id
      if (oldVal !== undefined) {
        this.form.Expertavdelingsid = 0
      }

      this.loadExpertAvdelingList()
    },
    'errors.items': function () {
      let vm = this
      let jq = window.jQuery

      // console.log(this.errors.items)
      setTimeout(() => {
        // Reset errors
        vm.sectionErrors = {}

        if (jq('.form-error').length) {
          jq('.form-error').each(function () {
            let section = jq(this).closest('.scroll-section')

            vm.sectionErrors[section.attr('id')] = jq('.form-error', section).length
          })
        }
      })
    }
  },
  computed: {
    hasAvdeling: function () {
      return !(this.form.Avdelingsid === null || this.form.Avdelingsid === '' || this.form.Avdelingsid < 0)
    }
  },
  methods: {
    makeFormItem: function () {
      let defaults = {
        Rolle: null,
        Avdelingsid: null,
        Expertavdelingsid: 0,
        Inaktiv: 'F',
        vin: 0,
        Ekspert: false,
        Minekunder: false,
        Mottakerforfirma: 'SENTRUM'
      }

      // Apply the checkbox values
      this.checkboxesBeforeLoad()

      // Apply default values
      this.$helpers.setObjectValues(defaults, this.bruker)

      // Clone kunde to the form object
      this.form = this._.clone(this.bruker)
    },
    checkboxesBeforeLoad: function () {
      // Default values and checked values for the W_* thingies
      Object.values(this.w_items).forEach(o => {
        let key = o.key

        if (this.bruker.hasOwnProperty(key)) {
          if (this.bruker[key] === 'T') {
            this.w_items_checked.push(key)
          }
        } else {
          this.bruker[key] = 'F'
        }
      })
    },
    checkboxesBeforeSave: function () {
      // Get checked checkboxes and add to bruker objekt
      Object.values(this.w_items).forEach(o => {
        let key = o.key

        if (this._.indexOf(this.w_items_checked, key) >= 0) {
          this.form[key] = 'T'
        } else {
          this.form[key] = 'F'
        }
      })
    },
    fetch: function () {
      this.loading = true

      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.rolle.unshift({key: this.form.Rolle, val: 'Laster...'})
      this.instillinger.avdeling.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      this.instillinger.expertavdeling.unshift({key: this.form.Expertavdelingsid, val: 'Velg ekspertavdeling'})

      BrukerService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.rolle = data.rolle
          this.instillinger.rolle.unshift({key: null, val: 'Velg rolle', disabled: true})

          this.instillinger.avdeling = data.avdeling
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})
        })
        .catch(() => {
          // Skip this error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.loading = false

          // Now submittable again
          this.setFormLoading(false)
        })
    },
    loadExpertAvdelingList: function () {
      this.instillinger.expertavdeling = []

      if (!this.hasAvdeling) {
        // If no avdeling is choosen
        this.form.Expertavdelingsid = null
        this.instillinger.expertavdeling.unshift({key: 0, val: 'Velg ekspertavdeling'})
      } else {
        // Load expertavdeling by selected avdeling
        this.instillinger.expertavdeling.unshift({key: this.form.Expertavdelingsid, val: 'Laster...'})

        MiscService.loadDropdownExpertavdeling(this.form.Avdelingsid)
          .then((data) => {
            this.instillinger.expertavdeling = data
            this.instillinger.expertavdeling.unshift({key: 0, val: 'Velg ekspertavdeling'})
            if (this.firstLoadExpertavdeling) {
              var vm = this
              setTimeout(function () {
                vm.form.Expertavdelingsid = vm.bruker.Expertavdelingsid
              })

              this.firstLoadExpertavdeling = false
            }
          })
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Parse W_* checkboxes and add to bruker object
            this.checkboxesBeforeSave()

            let brukerid = this.bruker.Brukerid || null

            // Remove passord
            if (this._.isEmpty(this.form.Passord)) {
              this.form.Passord = null
              this.form.PassordRepeat = null

              delete this.form.Passord
              delete this.form.PassordRepeat
            }

            let data = this._.clone(this.form)
            if (data.Expertavdelingsid === 0 || data.Expertavdelingsid === '0') {
              data.Expertavdelingsid = null
            }

            // And try to save
            BrukerService.save(brukerid, data)
              .then((response) => {
                // Update this.bruker with the response data
                this.$helpers.softClone(response.data, this.bruker)

                // And re create the form item
                this.firstLoadExpertavdeling = true
                this.makeFormItem()

                // Emit bruker save ok event
                this.$emit('bruker_form_saved', response.data)
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    uniqueBrukernavnCheck: function (value) {
      value = this._.toUpper(value)

      return new Promise(resolve => {
        // Compare to original value first, if save we allow it
        if (this.bruker.Brukernavn && value === this.bruker.Brukernavn) {
          resolve({valid: true})
          return
        }

        // Start brukernavn check
        this.burkernavnCheck = true

        // Try to load promise from cache
        let promise = this.brukernavnCheckCache.get(value)

        // See if we have a cached brukernavn
        if (!promise) {
          promise = BrukerService.findByBrukernavn(value)
          this.brukernavnCheckCache.set(value, promise)
        }

        // Now resolve / reject
        promise
          .then((response) => {
            if (response.data && response.data.Brukernavn === value) {
              resolve({valid: false, data: {message: 'Brukernavn finnes allerede'}})
            } else {
              resolve({valid: true})
            }
          })
          .catch(() => {
            resolve({valid: true})
          })
          .then(() => {
            this.burkernavnCheck = false
          })
      })
    },

    uniqueEmailCheck: function (value) {
      value = this._.toLower(value)

      return new Promise(resolve => {
        // Compare to original value first, if save we allow it
        if (this.bruker.Email && value === this._.toLower(this.bruker.Email)) {
          resolve({valid: true})
          return
        }

        // Start email check
        this.emailCheck = true

        // Try to load promise from cache
        let promise = this.emailCheckCache.get(value)

        // See if we have a cached email
        if (!promise) {
          promise = BrukerService.findByEmail(value)
          this.emailCheckCache.set(value, promise)
        }

        // Now resolve / reject
        promise
          .then((response) => {
            if (response.data && this._.toLower(response.data.Email) === value) {
              resolve({valid: false, data: {message: 'Email finnes allerede'}})
            } else {
              resolve({valid: true})
            }
          })
          .catch(() => {
            resolve({valid: true})
          })
          .then(() => {
            this.emailCheck = false
          })
      })
    }
  }
}
</script>

<style scoped>
input.uppercase {
  text-transform: uppercase;
}
input.lowercase {
  text-transform: lowercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/BrukerCardForm.vue